import 'zone.js'; // Angularが必要とするZone.js
window.global = window;
